// //////////////////////////////////////////////////////////////////////
// This file is generated in package.json under scripts/prebuild:config
// To change values here, don't edit this file. Edit /app.config.js
// and rerun 'npm run prebuild:config'
// //////////////////////////////////////////////////////////////////////
// Setup the env to match what we built with
if (globalThis.process !== undefined) {
	Object.assign(process.env, {
		NODE_ENV: 'production',
		RUBBER_BUILD_ENV: 'staging',
	});
}

// Import THIS in the front end instead of AppConfig
// so nothing private is exposed.
const PublicAppConfig = {
	...({
	"fbAppId": "1956399411421193",
	"fbBizLoginConfigId": "413912447634457",
	"fbApiVersion": "v18.0",
	"langfuse": {},
	"honeycomb": {},
	"languages": {
		"en": {
			"nativeName": "English",
			"longCode": "en-US",
			"simpleCode": "en"
		},
		"es": {
			"nativeName": "Spanish",
			"longCode": "es-MX",
			"simpleCode": "es"
		},
		"zh": {
			"nativeName": "Chinese",
			"longCode": "zh",
			"simpleCode": "zh"
		},
		"ar": {
			"nativeName": "Arabic",
			"longCode": "ar",
			"simpleCode": "ar"
		}
	},
	"vehicleTiers": {
		"sedan": {
			"title": "Luxury Sedan",
			"exampleText": "Mercedes-Benz E-Class, BMW 5 Series, Cadillac XTS or similar",
			"tierIndex": 1,
			"maxPassenger": 3
		},
		"suv": {
			"title": "Luxury SUV",
			"exampleText": "Mercedes-Benz V-Class, Chevrolet Suburban, Cadillac Escalade, Toyota Alphard or similar",
			"tierIndex": 2,
			"maxPassenger": 5
		},
		"limo": {
			"title": "Limo",
			"tierIndex": 3,
			"exampleText": "Cadillac Escalade ESV Stretch Limo or similar",
			"maxPassenger": 14
		},
		"exotic": {
			"title": "Exotic",
			"description": "Ferrari F8, Lamborghini Huracán, McLaren 720S, or similar",
			"tierIndex": 4,
			"maxPassenger": 2
		}
	},
	"newYorkCompliance": {
		"tlcLicensedForHireVehicleBases": "\n\t\t\t\t\t\tB03338 A & T NYC LIMO LLC\n\t\t\t\t\t\tB03340 CEO CHAUFFEURED SERVICES CORP\n\t\t\t\t\t\tB03321 CRESCENT LUXURY CLS, INC.\n\t\t\t\t\t\tB02253 CRESTWOOD CAR & LIMO SVC,LTD\n\t\t\t\t\t\tB02424 FRIENDLY RIDE INC\n\t\t\t\t\t\tB03197 LIMO TRIBE INC\n\t\t\t\t\t\tB03320 LIMOLINK INCORPORATED\n\t\t\t\t\t\tB02655 LONG ISLAND CITY CAR AND LIMO INC.\n\t\t\t\t\t\tB02949 MEEM SERVICES INC\n\t\t\t\t\t\tB02298 NYG LIMOUSINE LLC\n\t\t\t\t\t\tB02727 OSCAR LIMOUSINE INC\n\t\t\t\t\t\tB02027 PARIS LIMOUSINE SERVICE, CORP\n\t\t\t\t\t\tB02611 SS LIMOUSINE SERVICE INC\n\t\t\t\t\t\tB03334 WTM 365 INC.\n\t\t\t\t\t\tB03317 V & C, INC\n\t\t\t\t\t"
	},
	"tcpPort": 8095,
	"apiHost": "api-staging.josiahbryan.ai",
	"precinaApiHost": "api-staging.josiahbryan.ai",
	"gpsWorkerPublic": {
		"devWorkerRoot": "https://vaya-dev-gps.ngrok.io",
		"prodWorkerRoot": "https://gps-worker.vaya.workers.dev"
	},
	"valetTicketListWorkerPublic": {
		"devWorkerRoot": "https://vaya-dev-valet-ticket-list.ngrok.io",
		"prodWorkerRoot": "https://valet-ticket-list.vaya.workers.dev",
		"defaultEnabled": {
			"dev": false,
			"prod": false
		}
	},
	"valetTicketEditWorkerPublic": {
		"devWorkerRoot": "https://vaya-dev-valet-ticket-edits.ngrok.io",
		"prodWorkerRoot": "https://valet-ticket-edits.vaya.workers.dev"
	},
	"envRootUrls": {
		"dev": {
			"frontend": "http://localhost:3000",
			"api": "localhost:8095",
			"agentApi": "localhost:8095",
			"partners": "http://localhost:3001",
			"marketing": "http://localhost:8000"
		},
		"staging": {
			"frontend": "https://staging.josiahbryan.ai",
			"api": "api-staging.josiahbryan.ai",
			"partners": "https://partner.vayadriving.com",
			"marketing": "http://localhost:8000"
		},
		"prod": {
			"frontend": "https://app.vayavalet.io",
			"api": "api.vayavalet.io",
			"partners": "https://partner.vayadriving.com",
			"marketing": "https://vayadriving.com"
		}
	},
	"gigWageClientRoot": "https://sandbox.gigwage.com",
	"gaId": "UA-243284-47",
	"stripePubKey": "pk_test_51JW34iKJ8wMu6m4aMVFcV3A3KAIVztcclQquIhIsBQhf11GKG69cbl7cIl5KtIAluDpM5UhzCRjjQiwyAQWbVhaM00P4X5aFaw",
	"sentryDsn": "https://b44afb4cb55443ae89d6c520c2c921eb@o1050529.ingest.sentry.io/6031794",
	"googleMapsApiKey": "AIzaSyAXxLw5tzGnkxUXlJfkLoRJ9G52gB4vbMc",
	"geolocationDbKey": "fb363670-e22a-11eb-a464-59f706281067",
	"frontendRoot": "https://staging.josiahbryan.ai",
	"frontendV2Root": "http://localhost:3000",
	"frontendTunnelRoot": "https://vaya-dev-client.ngrok.io",
	"frontendValetApp": "https://app.vayavalet.io",
	"partnerRoot": "http://localhost:3001",
	"partnerTunnelRoot": "https://vaya-dev-partners.ngrok.io",
	"marketingRoot": "http://localhost:8000",
	"marketingTunnelRoot": "https://vaya-dev-marketing.ngrok.io",
	"betaAppProdRoot": "https://admin.vayadriving.com",
	"tipAppRoot": "https://tip.vayavalet.io",
	"tipAppDevTunnelRoot": "https://vaya-dev-tip.ngrok.io",
	"apiVayaValetIo": "api.vayavalet.io",
	"backendTunnelHost": "vaya-dev-api.ngrok.io",
	"pinExpiration": 3600000,
	"defaultStripeProductId": "prod_KkRxJlhMOgMnv1",
	"stripePackages": {
		"prod_KkRxJlhMOgMnv1": {
			"name": "Introductory Membership",
			"priceId": "price_1K4x3oKJ8wMu6m4aZV67tPbP",
			"price": 0,
			"hours": 0,
			"markup": 1.33,
			"customDescription": "Experience all the benefits of a private luxury driver in our fleet of luxury sedans, suburbans, and limos with no monthly subscription for 60 days",
			"referralCodeId": "Tier-Intro"
		},
		"prod_Lg4V8UlnGi0gZK": {
			"name": "Basic Package",
			"priceId": "price_1KyiM6KJ8wMu6m4aUqV52dJf",
			"price": 19,
			"hours": 0.25,
			"markup": 1.25,
			"customDescription": "Get a complimentary ride each month and select dedicated private drivers your own dedicated concierge staff",
			"referralCodeId": "Tier-Basic"
		},
		"prod_Lg4XIpclXrFV9x": {
			"name": "Advanced Package",
			"priceId": "price_1KyiOYKJ8wMu6m4aNpkhFVtX",
			"price": 99,
			"hours": 1,
			"markup": 1.2,
			"customDescription": "Priority access to exclusive luxury transportation and lifestyle Concierge services with personal vehicle driving and access to limousine fleets",
			"referralCodeId": "Tier-Elite"
		}
	},
	"phoneNumbers": {
		"main": "+15127227791",
		"notifications": "+15127227792",
		"driverMember": "+15127227794",
		"otp": "+17372379502"
	},
	"firebase": {
		"apiKey": "AIzaSyCXqd6yRHsk8QjoUv0rsCuuRPKp3tpgvtY",
		"authDomain": "vaya-driving-app.firebaseapp.com",
		"projectId": "vaya-driving-app",
		"storageBucket": "vaya-driving-app.appspot.com",
		"messagingSenderId": "747446149493",
		"appId": "1:747446149493:web:ad86b9458929bdbf97333c",
		"measurementId": "G-5S2VE51YW9"
	},
	"firebaseVapidMessagingKey": "BIi6SEv4QrUl35sfg1PZe0TuFEgsD5RTjR-mMvN9PRO7G3UT3BDvZ5NuIpAGq5jYsnCh7uwETngvOV68cKGaHXo",
	"firebaseOverrides": [
		{
			"originMatch": "meetatthemirror",
			"config": {
				"firebase": {
					"apiKey": "AIzaSyDriH7DPyvZozaeRlSD1V2F3oPOwFztWTk",
					"authDomain": "meet-at-the-mirror.firebaseapp.com",
					"projectId": "meet-at-the-mirror",
					"storageBucket": "meet-at-the-mirror.firebasestorage.app",
					"messagingSenderId": "234446360076",
					"appId": "1:234446360076:web:bf3c571e3b78dc09192829",
					"measurementId": "G-THYYDNKSZZ"
				},
				"firebaseVapidMessagingKey": "BAMnGcdwCZjO_i3cTOzES6EpcsA8Hxwbf_9kyaPtn_cgzXfDyFGgjXYXXsswKBMYC8pf3IzvQlx8fpb7EYIz_74"
			}
		}
	],
	"offlineSwHostAllowlist": [
		"app.johnoberg.com"
	],
	"hostWhiteLabel": [
		{
			"matchHosts": [
				"app.johnoberg.com"
			],
			"favicon": "/joa/favicon-32.png",
			"title": "John Oberg",
			"description": "Intersecting People and Performance. John Oberg Advisory helps leaders and organizations create meaningful business growth through better relationships, data and expertise.",
			"color": "#0D2838",
			"image": {
				"url": "/joa/favicon-512.png",
				"width": 512,
				"height": 512,
				"alt": "John Oberg Advisory"
			},
			"twitter": {
				"card": "summary_large_image"
			}
		},
		{
			"matchHosts": [
				"app.meetatthemirror.com"
			],
			"favicon": "https://meetatthemirror.com/favicon.ico",
			"title": "Meet at the Mirror",
			"description": "Austin's IRL Christian social network. Meet friends, build community, and discover what other Believers are doing in Austin this week.",
			"color": "#2D2F71",
			"image": {
				"url": "https://app.meetatthemirror.com/matm/og-default-1200x630.jpg",
				"width": 1200,
				"height": 630,
				"alt": "Meet at the Mirror"
			},
			"twitter": {
				"card": "summary_large_image"
			}
		},
		{
			"matchHosts": [
				"my.precina.com",
				"admin.precina.com"
			],
			"favicon": "https://precina.com/favicon.ico",
			"title": "Precina",
			"description": "Ending Type 2 Diabetes, Daily We’ve reimagined healthcare to meet the unique needs of people with type 2 diabetes. Our approach combines medical and mental health care with small, frequent adjustments, making it easier for you. You choose how we support you – daily if needed. We’re always monitoring your progress and ready to talk",
			"color": "#000000",
			"image": {
				"url": "https://precina.com/wp-content/uploads/2021/10/Precina@3x.png",
				"width": 736,
				"height": 226,
				"alt": "Precina"
			}
		},
		{
			"matchHosts": [
				"app.vayavalet.io"
			],
			"favicon": "http://admin.vayadriving.com/favicon.ico",
			"title": "Vaya Valet",
			"description": "Valet / Parking Operations, simplified in the cloud. Streamline your valet operations with the first and only “All-in-One” valet software solution — from scheduling to payments and reviews, Vaya does it all so you can grow your business like never before.",
			"color": "#000000",
			"image": {
				"url": "https://vayavalet.io/wp-content/uploads/2025/05/hero-screenshot.bd1c7eed-1.webp",
				"width": 946,
				"height": 840,
				"alt": "Vaya Valet"
			}
		},
		{
			"matchHosts": [
				"app.salesuplevel.com"
			],
			"favicon": "/salesuplevel/favicon-32.png",
			"title": "SalesUpLevel",
			"description": "AI Sales Career Gym — daily skill-building workouts that turn working sales reps into AI-fluent, top-performing pros. $25/month, no trial — your quiz is your trial.",
			"color": "#7C3AED",
			"image": {
				"url": "/salesuplevel/og-image.png",
				"width": 1200,
				"height": 630,
				"alt": "SalesUpLevel — AI Sales Career Gym"
			},
			"twitter": {
				"card": "summary_large_image"
			}
		}
	],
	"intercomAppId": "te7aodvw",
	"driverMaxPickupWaitMinutes": 60,
	"serviceAreas": [
		{
			"name": "Austin, TX",
			"timezone": "America/Chicago",
			"location": {
				"lat": 30.268064208179236,
				"lng": -97.74281181323757,
				"radius": 48280,
				"dispatchRadiusMeters": 48280.3
			},
			"eventPricingRules": [
				{
					"id": "late-night",
					"name": "Late Night",
					"description": "Late night trips on high-demand days",
					"specialPricingModifier": 2.5,
					"packageModifiers": {
						"silver": 1.6,
						"gold": 1.4,
						"platinum": 1.3,
						"diamond": 1.2
					},
					"times": [
						{
							"dayOfWeek": -1,
							"start": "19:45:00",
							"hours": 5
						},
						{
							"dayOfWeek": 5,
							"start": "20:00:00",
							"hours": 7
						},
						{
							"dayOfWeek": 6,
							"start": "20:00:00",
							"hours": 7
						},
						{
							"dayOfWeek": 0,
							"start": "20:00:00",
							"hours": 7
						}
					]
				}
			],
			"flatRateGeoRules": [
				{
					"id": "ride-25-downtown",
					"name": "$25 Rides",
					"description": "$25-One-Way Rides anywhere within the downtown radius",
					"flatRateCost": 20,
					"flatRatePrice": 25,
					"geofences": [
						{
							"lat": 30.263382454053133,
							"lng": -97.74454989455865,
							"meters": 2125
						},
						{
							"lat": 30.26326313645714,
							"lng": -97.72417986827942,
							"meters": 1820
						},
						{
							"lat": 30.268864673875296,
							"lng": -97.7243221368536,
							"meters": 1820
						}
					]
				}
			]
		}
	],
	"appStoreLinks": {
		"android": "https://play.google.com/store/apps/details?id=com.vayadriving",
		"ios": "https://apps.apple.com/us/app/vaya-concierge-driving/id1589326725"
	},
	"posthogCloudApiKey": "phc_7SelwAJSXVDNNSFp4kYlbiEe4bhkNL29PIicLTaurBj"
}),
	
	version: "2.3.2129-1727f9d-staging",

	gitVersionLong: "1727f9d89743b34fb2a6d33eca11e5527da42ea2",
	gitVersionShort: "1727f9d897",

	buildEnv: "staging",

	buildTime: "2026-11-04T04:03:21.868Z",

	buildArch: "armv7l",

	buildPlatform: "linux",

	// Generated as an MD5 of package-lock.json so we can tell if hotfix will work or not
	depHash: "183b64eb1a093f394c1a60abe4b8bdb4",

	// Set in Jenkins via the BUILD_NUMBER env var — CI-controlled, not just
	// human-typed, and not previously escaped at all (BDL-2855).
	buildNumber: "undefined",

};

export default PublicAppConfig;
